import { i as c, x as w, s as d } from "../../../lit-element-6iugfgmM.js";
import { e as v } from "../../../custom-element-wk-AooBb.js";
import { i as a } from "../../../query-D8_rwLua.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-action-button-CjSKZ-qO.js";
import "../../../sp-field-label-BwIfWLHz.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-classic-grid-view.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-view-list.js";
import b from "../../../events/ViewOptionEvent.js";
import { Localize as u } from "../../../lib/I18N.js";
const g = { "view-options.view-label": "View", "view-options.view-list-label": "List", "view-options.view-grid-label": "Grid" }, m = c`[part=option-button]{width:38px}div,sp-action-button{align-items:center;display:flex;justify-content:space-between}.view-options{align-items:flex-start;flex-direction:column}`;
var h = Object.defineProperty, f = Object.getOwnPropertyDescriptor, p = (l, t, o, i) => {
  for (var n, e = i > 1 ? void 0 : i ? f(t, o) : t, r = l.length - 1; r >= 0; r--) (n = l[r]) && (e = (i ? n(t, o, e) : n(e)) || e);
  return i && e && h(t, o, e), e;
};
let s = class extends u(d, g) {
  constructor() {
    super(...arguments), this.handleViewClick = (l) => {
      var o, i;
      const t = l.target.id.includes("list");
      (o = this.listViewBtn) == null || o.toggleAttribute("selected", t), (i = this.gridViewBtn) == null || i.toggleAttribute("selected", !t), this.dispatchEvent(new b(t));
    };
  }
  static get styles() {
    return m;
  }
  render() {
    return w`<div class="view-options"><sp-field-label>${this.t("view-options.view-label")}</sp-field-label><div><sp-action-button id="list-view-btn" label="${this.t("view-options.view-list-label")}" part="option-button" quiet @click="${this.handleViewClick}"><sp-icon-view-list slot="icon"></sp-icon-view-list><span part="option-button-label">${this.t("view-options.view-list-label")}</span></sp-action-button><sp-action-button id="grid-view-btn" label="${this.t("view-options.view-grid-label")}" part="option-button" quiet selected="selected" @click="${this.handleViewClick}"><sp-icon-classic-grid-view slot="icon"></sp-icon-classic-grid-view><span part="option-button-label">${this.t("view-options.view-grid-label")}</span></sp-action-button></div></div>`;
  }
};
p([a("#list-view-btn")], s.prototype, "listViewBtn", 2), p([a("#grid-view-btn")], s.prototype, "gridViewBtn", 2), s = p([v("af-view-options")], s);
const A = s;
export {
  A as default
};
//# sourceMappingURL=ViewOptions.js.map
